import { render, staticRenderFns } from "./CardAcupoint.vue?vue&type=template&id=beaae384&"
import script from "./CardAcupoint.vue?vue&type=script&lang=js&"
export * from "./CardAcupoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports